// extracted by mini-css-extract-plugin
export default {"bgGradient":"BgGradient--bgGradient--qJTzj"};